export function renderLogin(root, onSubmit) {
    root.innerHTML = `
        <div class="login-screen">
            <div class="login-card">
                <h1>Kapela</h1>
                <p class="subtitle">Správa akcí – přihlášení</p>
                <form id="login-form">
                    <label>
                        <span>E-mail</span>
                        <input type="email" name="email" required autocomplete="email">
                    </label>
                    <label>
                        <span>Heslo</span>
                        <input type="password" name="password" required autocomplete="current-password">
                    </label>
                    <button type="submit" class="btn btn-primary">Přihlásit se</button>
                    <p class="error" id="login-error" hidden></p>
                </form>
            </div>
        </div>
    `;

    const form = root.querySelector('#login-form');
    const err = root.querySelector('#login-error');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        err.hidden = true;
        const fd = new FormData(form);
        try {
            await onSubmit(fd.get('email'), fd.get('password'));
        } catch (ex) {
            err.textContent = ex.message || 'Přihlášení se nezdařilo.';
            err.hidden = false;
        }
    });
}
